module.exports = __webpack_public_path__ + "static/media/drawer3-ocean.07e14f7a.png";